var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-popup"},[_c('PopupSmartfarm'),_c('br'),_c('PopupSetting'),_c('br'),_c('PopupCropsForm'),_c('br'),_c('PopupAsForm'),_c('br'),_c('PopupAsView'),_c('br'),_c('PopupNotice')],1)}
var staticRenderFns = []

export { render, staticRenderFns }